import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { FeedsListState, FEEDS_SLICE_NAME } from './models';

export const feedSelector = (state: RootState): FeedsListState => state[FEEDS_SLICE_NAME];

export const selectFeedsIsLoading = createSelector(feedSelector, (state: FeedsListState) => state.isLoading);

export const selectFeedsList = createSelector(feedSelector, (state: FeedsListState) => state.feedsList);

export const selectQuery = createSelector(feedSelector, (state: FeedsListState) => state.query);
